import * as React from 'react';
import PdfPage from '@payscale/payscale-shared-ui/lib/Pdf/PdfPage';
import PdfContent from '@payscale/payscale-shared-ui/lib/Pdf/PdfContent';
import { CompPageTitle } from 'nomst/Components/CompReport/compPageTitle';
import { CompPagePayInfo } from 'nomst/Components/CompReport/compPagePayInfo';
import { CompPagePromotion } from 'nomst/Components/CompReport/compPagePromotion';
import { CompTable } from 'nomst/Components/CompReport/compTable';
import { Employee } from 'nomst/Stores/Decision/employee';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import './compReportCompPage.scss';

interface ICompReportCompPageProps {
    employee: Nullable<Employee>;
    configuration: Configuration;
}

const CompReportCompPage = (props: ICompReportCompPageProps): React.ReactElement => {
    const { employee, configuration } = props;

    if (!employee) {
        return <></>;
    }

    return (
        <PdfPage>
            <PdfContent>
                <div className="comp-report-comp-page">
                    <CompPageTitle
                        employeeName={employee.displayName}
                        jobTitle={employee.jobTitleInternal}
                        payEffectiveDate={configuration.payEffectiveDate}
                    />
                    <div className="comp-report-comp-page__pay-section">
                        <CompPagePayInfo
                            value={employee.currentPay}
                            currencyCode={employee.isoCurrencyCode}
                            format={configuration.format}
                            isHourly={employee.isHourly}
                            fullTimeEquivalent={employee.fullTimeEquivalent}
                        />
                        <CompPagePayInfo
                            value={employee.newPay}
                            isNewPay={true}
                            currencyCode={employee.isoCurrencyCode}
                            format={configuration.format}
                            isHourly={employee.isHourly}
                            fullTimeEquivalent={employee.fullTimeEquivalent}
                        />
                        {!!employee.compMemoPromotionRequest && <CompPagePromotion
                            jobTitle={employee.compMemoPromotionRequest.proposedJobTitle}
                        />}
                    </div>
                    <CompTable
                        employee={employee}
                        configuration={configuration}
                    />
                </div>
            </PdfContent>
        </PdfPage>
    );
};

export default CompReportCompPage;
export { CompReportCompPage };